import {computed, makeObservable} from 'mobx';
import {DesignCollection} from '../../../stores/DesignCollection';
import {maxFieldsToShow} from '../consts/consts';
import {hiddenFieldTypes} from '../../../../../../constants/FieldConsts';
import {SubscreenField} from './SubscreenField';

export class SubscreenCollection extends DesignCollection {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    insertFields(parentField, children) {
        this.fields.clear();
        children.fields.forEach((f, idx) => {
            const newField = new SubscreenField(f, parentField);
            if (idx >= maxFieldsToShow) {
                newField.setHide(hiddenFieldTypes.HIDDEN);
            }
            newField.setCollection(f);
            this.fields.push(newField);
        });
    }

    @computed
    get firstHiddenIdx() {
        const hiddenIdx = this.fields.findIndex(field => field.hidden);
        return hiddenIdx >= 0 && hiddenIdx <= maxFieldsToShow - 1 ? hiddenIdx : maxFieldsToShow;
    }
}
